// extracted by mini-css-extract-plugin
export default {"page":"UnauthenticatedLayout_page__eWWre","main":"UnauthenticatedLayout_main__lRUhi","footer":"UnauthenticatedLayout_footer__zdZmy"};